import { useState, useEffect } from "react";
import StudentAffirmationComponentTranslation from "../translations/StudentAffirmationComponentTranslation";

function StudentAffirmationComponent({ children, langCode, view, handleStep, studentStudiesForm, setStudentStudiesForm, setDisabledSubmit, saveDraft }) {

    const [checkbox1, setCheckbox1] = useState(false);
    const [checkbox2, setCheckbox2] = useState(false);
    const [radioButton, setRadioButton] = useState(false)

    useEffect(() => {
        if (studentStudiesForm?.communicationAccept) {
            setRadioButton(true)
        }

        if (studentStudiesForm?.gradesConfirm) {
            setCheckbox1(true)
        }

        if (studentStudiesForm?.gdprConfirm) {
            setCheckbox2(true)
        }
    }, [])

    useEffect(() => {
        console.log(studentStudiesForm)
    }, [])

    useEffect(() => {
        setDisabledSubmit(!checkbox1 || !checkbox2)
        setStudentStudiesForm({ ...studentStudiesForm, communicationAccept: radioButton, gradesConfirm: checkbox1, gdprConfirm: checkbox2 })
    }, [checkbox1, checkbox2])

    return (
        <form className="g-3 needs-validation" noValidate={false} onSubmit={(e) => {
            e.preventDefault();
            setStudentStudiesForm({ ...studentStudiesForm, communicationAccept: radioButton, gradesConfirm: checkbox1, gdprConfirm: checkbox2 })
            var activeElement = document.activeElement;
            if (activeElement.value === 'draft') {
                saveDraft({ ...studentStudiesForm, communicationAccept: radioButton, gradesConfirm: checkbox1, gdprConfirm: checkbox2 })
            }
        }}>
            <div className="containter">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card p-4">
                            <h3 className="text-center">{StudentAffirmationComponentTranslation("h3_title", langCode)['label']}</h3>
                            <div>
                                <p className="font-weight-bold">
                                    Συμφωνώ ότι αν η αίτησή μου γίνει δεκτή, τα στοιχεία επικοινωνίας μου θα είναι διαθέσιμα, κατόπιν αιτήσεως, σε φοιτητές από το ΑΠΘ που επιθυμούν να επικοινωνήσουν για να τους πληροφορήσω σχετικά με την εμπειρία που είχα στο εξωτερικό. Με εξαίρεση αυτές τις λεπτομέρειες, όλα τα άλλα δεδομένα θα αντιμετωπιστούν εμπιστευτικά. *
                                </p>
                            </div>
                            <div className="ml-2">
                                <div class="form-check">
                                    <input class="form-check-input" disabled={view} type="radio" name="flexRadioDisabled" id="flexRadioDisabled" checked={radioButton} onChange={(e) => {
                                        if (e.target.checked === true) {
                                            setRadioButton(true)
                                        } else {
                                            setRadioButton(false)
                                        }
                                    }} />
                                    <label class="form-check-label" for="flexRadioDisabled">
                                        Ναι
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" disabled={view} type="radio" name="flexRadioDisabled" id="flexRadioCheckedDisabled" checked={!radioButton} onChange={(e) => {
                                        if (e.target.checked === true) {
                                            setRadioButton(false)
                                        } else {
                                            setRadioButton(true)
                                        }
                                    }} />
                                    <label class="form-check-label" for="flexRadioCheckedDisabled">
                                        Οχι
                                    </label>
                                </div>
                            </div>
                            <div className="m-2">
                                <div class="form-check">
                                    <input class="form-check-input" disabled={view} type="checkbox" value="" id="checkbox1" checked={checkbox1} onChange={(e) => {
                                        if (e.target.checked === true) {
                                            setCheckbox1(true)
                                        } else {
                                            setCheckbox1(false)
                                        }
                                    }} />
                                    <label class="form-check-label" for="checkbox1" className="font-weight-bold">
                                        Βεβαιώνω ότι όλες οι πληροφορίες που περιλαμβάνονται στο έντυπο της αίτησης είναι αληθείς και πλήρεις και ότι τα συνημμένα σε αυτή έγγραφα είναι ακριβή αντίγραφα των πρωτότυπων και
                                        συναινώ στην ηλεκτρονική διάθεση των στοιχείων της αναλυτικής μου βαθμολογίας από το σύστημα Ηλεκτρονικής Γραμματείας στο Τμήμα Ευρωπαϊκών Εκπαιδευτικών Προγραμμάτων για τους σκοπούς της αξιολόγησης της αίτησής μου. *
                                    </label>
                                </div>
                            </div>
                            <hr
                                style={{
                                    height: 0.2
                                }}
                            />
                            <div className="form-group mt-2">
                                <p className="font-weight-bold">
                                    ΕΝΗΜΕΡΩΣΗ ΚΑΙ ΠΡΟΣΒΑΣΗ ΣΕ ΔΕΔΟΜΕΝΑ ΠΡΟΣΩΠΙΚΟΥ ΧΑΡΑΚΤΗΡΑ
                                </p>
                                <p>
                                    Υπεύθυνος επεξεργασίας των προσωπικών δεδομένων είναι το ΑΠΘ.
                                </p>
                                <p>
                                    Η συλλογή και επεξεργασία των προσωπικών δεδομένων γίνεται με σκοπό την πλήρωση των νόμιμων προϋποθέσεων και υποχρεώσεων, που οφείλει να τηρήσει το ΑΠΘ για την υλοποίηση του προγράμματος ERASMUS +. Βασικό στοιχείο της επεξεργασίας αυτής αποτελεί η ηλεκτρονική διαβίβαση των στοιχείων της αναλυτικής βαθμολογίας του αιτούντος φοιτητή από το σύστημα Ηλεκτρονικής Γραμματείας στο Τμήμα Ευρωπαϊκών Εκπαιδευτικών Προγραμμάτων για τους σκοπούς αξιολόγησης της υπό κρίση αίτησης.
                                </p>
                                <p>
                                    Αποδέκτης των προσωπικών δεδομένων είναι το πανεπιστήμιο υποδοχής του αιτούντος φοιτητή, το οποίο μπορεί να βρίσκεται κατά περίπτωση εντός ή εκτός ΕΕ.
                                </p>
                                <p>
                                    Ως χρονικό διάστημα αποθήκευσης των προσωπικών δεδομένων ορίζονται τα δέκα έτη από τη συλλογή τους ως απαραίτητος χρόνος για την εξυπηρέτηση του συγκεκριμένου σκοπού.
                                </p>
                                <p>
                                    Σύμφωνα με τον Γενικό Κανονισμό Προστασίας Προσωπικών Δεδομένων (ΕΕ) 2016/679 και λαμβάνοντας υπόψη τους περιορισμούς, που διέπουν το νομοθετικό πλαίσιο του προγράμματος ERASMUS +, τα υποκείμενα των δεδομένων έχουν τα κάτωθι δικαιώματα:
                                </p>
                                <ul>
                                    <li><b>Δικαίωμα πρόσβασης στα δεδομένα</b> δηλαδή το δικαίωμα να γνωρίζουν τι είδους δεδομένα διατηρεί το ΑΠΘ, αν τα δεδομένα αυτά υφίστανται επεξεργασία, με ποιο τρόπο και για ποιο σκοπό.</li>
                                    <li><b>Δικαίωμα διόρθωσης των δεδομένων</b> δηλαδή το δικαίωμα να ζητηθεί η διόρθωση των προσωπικών δεδομένων αν αυτά είναι ανακριβή ή ελλιπή.
                                    </li>
                                    <li><b>Δικαίωμα διαγραφής των δεδομένων</b> ("Δικαίωμα στη λήθη"): το δικαίωμα να ζητηθεί η διαγραφή ή κατάργηση των προσωπικών δεδομένων τηρουμένων των νόμιμων προϋποθέσεων.</li>
                                    <li><b>Δικαίωμα περιορισμού της επεξεργασίας των δεδομένων δηλαδή</b> το δικαίωμα να ζητηθεί ο περιορισμός της επεξεργασίας των προσωπικών δεδομένων τηρουμένων των νόμιμων προϋποθέσεων.</li>
                                    <li><b>Δικαίωμα στη φορητότητα των δεδομένων</b> δηλαδή το δικαίωμα να ζητηθεί η αποστολή των προσωπικών δεδομένων σε τρίτο.
                                    </li>
                                    <li><b>Δικαίωμα ανάκλησης της συγκατάθεσής τους</b> όπου αυτή απαιτείται</li>
                                    <li><b>Δικαίωμα υποβολής καταγγελίας</b> στην εποπτική αρχή
                                    </li>
                                </ul>
                                <p>
                                    Αν η διαβίβαση γίνει σε χώρα για την οποία υφίσταται απόφαση επάρκειας της Ευρωπαϊκής Επιτροπής σχετικά με τη χώρα εκτός ΕΕ (τρίτη χώρα), τότε η διαβίβαση ακολουθεί τους κανόνες που αφορούν τη διαβίβαση σε χώρα εντός της Ε.Ε.
                                </p>
                                <p>
                                    Μέχρι σήμερα (12 Μαρτίου 2019) οι τρίτες χώρες για τις οποίες υφίσταται απόφαση επάρκειας της Ευρωπαϊκής Επιτροπής και ως εκ τούτου θεωρούνται ότι διασφαλίζουν επαρκές επίπεδο προστασίας όσον αφορά τη διαβίβαση προσωπικών δεδομένων είναι οι εξής: Ανδόρα, Αργεντινή, Καναδά, νήσους Φερόες, Γκέρνσει, Ισραήλ, νήσο το Μαν, Τζέρσει, Νέα Ζηλανδία, Ελβετία, Ουρουγουάη, ΗΠΑ και Ιαπωνία. Ενημέρωση σχετικά με τις χώρες για τις οποίες υφίσταται απόφαση επάρκειας υπάρχουν στον παρακάτω σύνδεσμο: <a href="https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/adequacy-protection-personal-data-non-eu-countries_en">https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/adequacy-protection-personal-data-non-eu-countries_en</a>
                                </p>
                                <p>
                                    Αν δεν υφίσταται απόφαση επάρκειας τότε η διαβίβαση των προσωπικών δεδομένων στην τρίτη χώρα δηλαδή σε χώρα εκτός ΕΕ μπορεί να γίνει εφόσον κρίνεται απαραίτητη για την εκτέλεση σύμβασης που συνήφθη προς όφελος του υποκειμένου των δεδομένων μεταξύ του ΑΠΘ ως υπεύθυνου επεξεργασίας και άλλου πανεπιστημίου στα πλαίσια του προγράμματος ERASMUS+.
                                </p>
                                <p>
                                    Σε κάθε περίπτωση το υποκείμενο των δεδομένων οφείλει να είναι ενημερωμένο για τους ενδεχόμενους κινδύνους, που μπορεί να προκύψουν από την επεξεργασία δεδομένων προσωπικού χαρακτήρα. Τέτοιοι κίνδυνοι ενδέχεται να είναι: υλική ή μη υλική βλάβη, διακρίσεις, κατάχρηση, υποκλοπή ταυτότητας, οικονομική απώλεια, βλάβη φήμης, απώλεια της εμπιστευτικότητας των δεδομένων προσωπικού χαρακτήρα που προστατεύονται από επαγγελματικό απόρρητο, παράνομη άρση της ψευδωνυμοποίησης ή οποιοδήποτε άλλο σημαντικό οικονομικό ή κοινωνικό μειονέκτημα. Επίσης στους κινδύνους αυτούς εμπεριέχεται η επεξεργασία δεδομένων προσωπικού χαρακτήρα, τα οποία αποκαλύπτουν φυλετική ή εθνοτική καταγωγή, πολιτικά φρονήματα, θρησκεία ή φιλοσοφικές πεποιθήσεις ή συμμετοχή σε συνδικάτα, τη σεξουαλική ζωή ή ποινικές καταδίκες και αδικήματα ή σχετικά μέτρα ασφάλειας, η αξιολόγηση προσωπικών πτυχών ιδίως όταν επιχειρείται ανάλυση ή πρόβλεψη πτυχών που αφορούν τις επιδόσεις στις σπουδές, την οικονομική κατάσταση, την υγεία, προσωπικές προτιμήσεις ή συμφέροντα, την αξιοπιστία ή τη συμπεριφορά, τη θέση ή μετακινήσεις, προκειμένου να δημιουργηθούν ή να χρησιμοποιηθούν προσωπικά προφίλ.
                                </p>
                                <p>
                                    Περισσότερες πληροφορίες για την προστασία των προσωπικών δεδομένων στο Α.Π.Θ. μπορείτε να βρείτε στην ακόλουθη ιστοσελίδα <a href="https://www.auth.gr/gdpr">https://www.auth.gr/gdpr</a>
                                </p>
                            </div>
                            <div className="m-2">
                                <div class="form-check">
                                    <input class="form-check-input" disabled={view} type="checkbox" value="" id="checkbox2" checked={checkbox2} onChange={(e) => {
                                        if (e.target.checked === true) {
                                            setCheckbox2(true)
                                        } else {
                                            setCheckbox2(false)
                                        }
                                    }} />
                                    <label class="form-check-label" for="checkbox2" className="font-weight-bold">
                                        Συμφωνώ με τους ανωτέρω Όρους Πολιτικής Προστασίας Δεδομένων Προσωπικού Χαρακτήρα. *
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {children}
        </form >
    );
}

export default StudentAffirmationComponent